function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        margin-left: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n            flex-basis: ", ";\n            max-width: ", ";\n          "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { css } from 'styled-components';
import { themeConfig } from "../../theme";
import { mediaQueryFunctionsListWithLimits, isInteger, calculatePercentageGridValue } from "../../theme/helpers";
import { getBreakpoints, getGridSize, getBaseIndent, getGutterWidth } from "../../theme/selectors";

var createBreakpointsStyles = function createBreakpointsStyles(props) {
  var theme = props.theme;
  var gridSize = getGridSize(theme);
  var breakpoints = getBreakpoints(theme);
  var mediaQueries = mediaQueryFunctionsListWithLimits(breakpoints);
  return Object.keys(props).filter(function (breakpoint) {
    return themeConfig.breakpointNames.indexOf(breakpoint) > -1;
  }).sort(function (breakpoint1, breakpoint2) {
    return themeConfig.breakpointNames.indexOf(breakpoint1) - themeConfig.breakpointNames.indexOf(breakpoint2);
  }).map(function (breakpoint) {
    return isInteger(props[breakpoint]) ? mediaQueries[breakpoint](_templateObject(), calculatePercentageGridValue(props[breakpoint], gridSize), calculatePercentageGridValue(props[breakpoint], gridSize)) : mediaQueries[breakpoint](_templateObject2(), props[breakpoint] === true ? "\n            flex-grow: 1;\n            flex-basis: 0;\n            max-width: 100%;\n            " : "\n              display: none;\n            ");
  });
};

var createBreakpointOffsetStyles = function createBreakpointOffsetStyles(props) {
  var theme = props.theme;
  return Object.keys(props).filter(function (breakpoint) {
    return themeConfig.breakpointOffsetNames.indexOf(breakpoint) > -1;
  }).map(function (breakpoint) {
    return mediaQueryFunctionsListWithLimits(getBreakpoints(theme))[breakpoint.replace(/Offset/g, '')](_templateObject3(), calculatePercentageGridValue(props[breakpoint], getGridSize(theme)));
  });
};

var Col = styled.div.withConfig({
  displayName: "Col",
  componentId: "sc-9fxtda-0"
})(["box-sizing:border-box;", " max-width:100%;", " flex-direction:column;", " ", ""], function (_ref) {
  var grow = _ref.grow;
  return "flex-grow: ".concat(+!!grow, ";");
}, function (_ref2) {
  var theme = _ref2.theme;
  var colPadding = "".concat(getGutterWidth(theme) * getBaseIndent(theme), "px");
  return css(["padding-right:", ";padding-left:", ";"], colPadding, colPadding);
}, createBreakpointsStyles, createBreakpointOffsetStyles);
export default Col;